import { ClientConfig, createWalletClient, formatEther, Hash, RpcTransactionReceipt, Transport, webSocket } from "viem";
import { getBalance } from "viem/actions";
import { UserOperation, UserOperationReceipt } from "viem/account-abstraction";
import { handleOp } from "../handleOp";
import { chain } from "../chain";
import { gasEstimator } from "./gasEstimator";
import { createBurnerAccount } from "@latticexyz/common";
import { transactionQueue } from "@latticexyz/common/actions";

export const localExecutorOptions = {
  chain,
  transport: gasEstimator(webSocket()),
  pollingInterval: 100,
} as const satisfies ClientConfig;

const params = new URLSearchParams(window.location.search);
const privateKey =
  params.get("privateKey") ||
  import.meta.env.VITE_PRIVATE_KEY ||
  "0xac0974bec39a17e36ba4a6b4d238ff944bacb478cbed5efcae784d7bf4f2ff80";

export const localUserOpExecutor = createWalletClient({
  ...localExecutorOptions,
  account: createBurnerAccount(privateKey),
}).extend(transactionQueue());

console.log(
  "optional local user op executor",
  localUserOpExecutor.account.address,
  formatEther(await getBalance(localUserOpExecutor, { address: localUserOpExecutor.account.address })),
);

export function localUserOps<const transport extends Transport>(originalTransport: transport): transport {
  return ((opts) => {
    const { request: originalRequest, ...rest } = originalTransport(opts);

    const receipts = new Map<Hash, RpcTransactionReceipt | UserOperationReceipt>();

    return {
      ...rest,
      async request(req) {
        console.log("local user op request", req);
        if (req.method === "eth_sendUserOperation") {
          const timeBeforeSubmit = Date.now();
          const result = await handleOp({
            submitter: localUserOpExecutor,
            userOp: (req as { params: [UserOperation<"0.7">] }).params[0],
          });
          console.log("handleUserOp:", Date.now() - timeBeforeSubmit);
          receipts.set(result.userOpHash, {
            success: true,
            userOpHash: result.userOpHash,
            receipt: { transactionHash: result.transactionHash },
          } as any);

          return result.userOpHash;
        }

        if (req.method === "eth_getUserOperationReceipt") {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const hash = (req.params as any)[0] as Hash;
          const receipt = receipts.get(hash) ?? ((await originalRequest(req)) as UserOperationReceipt);
          if (!receipts.has(hash)) receipts.set(hash, receipt);
          return receipt;
        }

        return originalRequest(req);
      },
    };
  }) as transport;
}
